import { render, staticRenderFns } from "./SettingsSystemSettingsDocumentNumberTemplateEditView.vue?vue&type=template&id=c201f076&scoped=true&"
import script from "./SettingsSystemSettingsDocumentNumberTemplateEditView.vue?vue&type=script&lang=js&"
export * from "./SettingsSystemSettingsDocumentNumberTemplateEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c201f076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c201f076')) {
      api.createRecord('c201f076', component.options)
    } else {
      api.reload('c201f076', component.options)
    }
    module.hot.accept("./SettingsSystemSettingsDocumentNumberTemplateEditView.vue?vue&type=template&id=c201f076&scoped=true&", function () {
      api.rerender('c201f076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/system-settings/document-number-template/SettingsSystemSettingsDocumentNumberTemplateEditView.vue"
export default component.exports